/* eslint-disable react/jsx-no-literals */
import { ApplicationProvider } from './common/context';
import { FormattedMessage, IntlProvider } from "react-intl";
import { Helmet } from 'react-helmet';
import { bool } from 'prop-types';
import { gaEvent } from './common/ga';
import { message } from 'antd';
import Header from './components/header/header';
import React, { useState } from 'react';
import Tab from './components/tab/tab';
import ga from 'react-ga';
import get from 'lodash/fp/get';
import translationsPt from "./translations/pt.json";
import translationsEn from "./translations/en.json";


const initialState = {
  evaluation: {
    1: {
      btnLabel: <FormattedMessage id="homepage.evaluation.1.btnLabel"/>,
      description: <FormattedMessage id="homepage.evaluation.1.description"/>,
      description2: <FormattedMessage id="homepage.evaluation.1.description2"/>,
      label: <FormattedMessage id="homepage.evaluation.1.label"/>,
      lead: <FormattedMessage id="homepage.evaluation.1.lead"/>,
      name: <FormattedMessage id="homepage.evaluation.1.name"/>,
      question: <FormattedMessage id="homepage.evaluation.1.question"/>,
      question2: <FormattedMessage id="homepage.evaluation.1.question2"/>,
      subtitle: <FormattedMessage id="homepage.evaluation.1.subtitle"/>,
      title: 'RISK CHECK'
    },
    2: {
      1: {
        text: [
          <FormattedMessage id="homepage.evaluation.2.1.text1"/>,
          <FormattedMessage id="homepage.evaluation.2.1.text2"/>,
          <FormattedMessage id="homepage.evaluation.2.1.text3"/>],
        title: <FormattedMessage id="homepage.evaluation.2.1.title"/>

      },
      2: {
        text: [
          <FormattedMessage id="homepage.evaluation.2.2.text1"/>,
          <FormattedMessage id="homepage.evaluation.2.2.text2"/>,
          <FormattedMessage id="homepage.evaluation.2.2.text3"/>
        ]

      },
      3: {
        text: [
          <FormattedMessage id="homepage.evaluation.2.3.text1"/>,
          <FormattedMessage id="homepage.evaluation.2.3.text2"/>,
          <FormattedMessage id="homepage.evaluation.2.3.text3"/>,
          <FormattedMessage id="homepage.evaluation.2.3.text4"/>,],
        title: <FormattedMessage id="homepage.evaluation.2.3.title"/>,

      },
      4: {
        text: [
          <FormattedMessage id="homepage.evaluation.2.4.text1"/>,
          <FormattedMessage id="homepage.evaluation.2.4.text2"/>,
          <FormattedMessage id="homepage.evaluation.2.4.text3"/>]

      },
      5: {
        text: []
      },
      6: {
        text: []
      },
      name: <FormattedMessage id="homepage.evaluation.2.name"/>,
      question: null,
      subtitle: <FormattedMessage id="homepage.evaluation.2.subtitle"/>,
      title: 'RISK CHECK'
    },
    3: {
      name: <FormattedMessage id="homepage.evaluation.3.name"/>

    },
    form: [],
    totals: []
  },
  matrix: {
    1: {
      btnLabel: <FormattedMessage id="homepage.matriz.1.btnLabel"/>,
      description: <FormattedMessage id="homepage.matriz.1.description"/>,
      description2: <FormattedMessage id="homepage.matriz.1.description2"/>,
      lead: <FormattedMessage id="homepage.matriz.1.lead"/>,
      name: <FormattedMessage id="homepage.matriz.1.name"/>,
      question: <FormattedMessage id="homepage.matriz.1.question"/>,
      question2: <FormattedMessage id="homepage.matriz.1.question2"/>,
      subtitle: <FormattedMessage id="homepage.matriz.1.subtitle"/>,
      title: 'PROJECT CHECK'
    },
    2: {
      1: {
        subtitle: <FormattedMessage id="homepage.matriz.2.1.subtitle"/>,
        text: [
          <FormattedMessage id="homepage.matriz.2.1.text1"/>,
          <FormattedMessage id="homepage.matriz.2.1.text2"/>,
          <FormattedMessage id="homepage.matriz.2.1.text3"/>,
          <FormattedMessage id="homepage.matriz.2.1.text4"/>],
        title: <FormattedMessage id="homepage.matriz.2.1.title"/>,
        tooltip: [
          <FormattedMessage id="homepage.matriz.2.1.tooltip1"/>,
          <FormattedMessage id="homepage.matriz.2.1.tooltip2"/>,
          <FormattedMessage id="homepage.matriz.2.1.tooltip3"/>,
          <FormattedMessage id="homepage.matriz.2.1.tooltip4"/>,
        ]
      },
      2: {
        subtitle: <FormattedMessage id="homepage.matriz.2.2.subtitle"/>,
        text: [
          <FormattedMessage id="homepage.matriz.2.2.text1"/>,
          <FormattedMessage id="homepage.matriz.2.2.text2"/>,
          <FormattedMessage id="homepage.matriz.2.2.text3"/>,
        ],
        tooltip: [
          <FormattedMessage id="homepage.matriz.2.2.tooltip1"/>,
          <FormattedMessage id="homepage.matriz.2.2.tooltip2"/>,
          <FormattedMessage id="homepage.matriz.2.2.tooltip3"/>,
        ]
      },
      3: {
        subtitle:  <FormattedMessage id="homepage.matriz.2.3.subtitle"/>,
        text: [
          <FormattedMessage id="homepage.matriz.2.3.text1"/>,
          <FormattedMessage id="homepage.matriz.2.3.text2"/>,
          <FormattedMessage id="homepage.matriz.2.3.text3"/>,],
        title: <FormattedMessage id="homepage.matriz.2.3.title"/>,
        tooltip: [
          <FormattedMessage id="homepage.matriz.2.3.tooltip1"/>,
          <FormattedMessage id="homepage.matriz.2.3.tooltip2"/>,
          <FormattedMessage id="homepage.matriz.2.3.tooltip3"/>
        ]
      },
      4: {
        subtitle: <FormattedMessage id="homepage.matriz.2.4.subtitle"/>,
        text: [
          <FormattedMessage id="homepage.matriz.2.4.text1"/>,
          <FormattedMessage id="homepage.matriz.2.4.text2"/>,
          <FormattedMessage id="homepage.matriz.2.4.text3"/>
        ],
        tooltip: [
          <FormattedMessage id="homepage.matriz.2.4.tooltip1"/>,
          <FormattedMessage id="homepage.matriz.2.4.tooltip2"/>,
          <FormattedMessage id="homepage.matriz.2.4.tooltip3"/>
        ]
      },
      5: {
        subtitle: <FormattedMessage id="homepage.matriz.2.5.subtitle"/>,
        text: [
          <FormattedMessage id="homepage.matriz.2.5.text1"/>,
          <FormattedMessage id="homepage.matriz.2.5.text2"/>
        ],
        title: <FormattedMessage id="homepage.matriz.2.5.title"/>,
        tooltip: [
          <FormattedMessage id="homepage.matriz.2.5.tooltip1"/>,
          <FormattedMessage id="homepage.matriz.2.5.tooltip2"/>
        ]
      },
      6: {
        subtitle:  <FormattedMessage id="homepage.matriz.2.6.subtitle"/>,
        text: [
          <FormattedMessage id="homepage.matriz.2.6.text1"/>,
          <FormattedMessage id="homepage.matriz.2.6.text2"/>
        ],
        tooltip: [
          <FormattedMessage id="homepage.matriz.2.6.tooltip1"/>,
          <FormattedMessage id="homepage.matriz.2.6.tooltip2"/>
        ]
      },
      name: <FormattedMessage id="homepage.matriz.2.name"/>,
      question: null,
      subtitle: <FormattedMessage id="homepage.matriz.2.subtitle"/>,
      title: 'PROJECT CHECK'

    },
    3: {
      name: <FormattedMessage id="homepage.matriz.3.name"/>,
    },
    avaliationForm: {},
    form: []
  },
  tab: '1'
};

// eslint-disable-next-line no-process-env
ga.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY);
// eslint-disable-next-line no-undef
ga.pageview(window.location.pathname + window.location.search);

/**
 *
 * @param { isEvaluation: boolean, isMatrix: boolean } props
 */

function App(props) {
  const pathname = window.location.href;
  const langSplit = pathname.split('=');
  const languageQuery = langSplit.length > 1 && langSplit[1] == 'en' ? 'en' : 'pt';
  const [language] = useState(languageQuery);
  const [languageTranslation] = useState(languageQuery === 'pt' ? translationsPt : translationsEn);
  const [state, setState] = useState(initialState);
  const prefix = props.isMatrix ? 'matrix' : 'evaluation';
  const avaliationForms = [];

  const print = () => {
    // eslint-disable-next-line no-undef
    window.print();
  };

  /**
   * Change Language.
   */

  const handleChangeLanguage = (value) => {
      return window.location = window.location.origin + window.location.pathname + '?lang=' + value;
  }

  const handleSetAvaliationForm = (column, form) => {
    avaliationForms[column] = form;
  };

  const handleSubmitAvaliationForm = () => {
    if (avaliationForms.length) {
      avaliationForms.map(form => {
        form.validateFields();
      });
    }
  };

  const setSwipper = swipper => {
    setState({
      ...state,
      swipper
    });
  };

  const handleChangeTab = tabIndex => {
    let tabName = '';

    if (tabIndex === '1') {
      tabName = 'Overview';
    } else if (tabIndex === '2') {
      tabName = 'Form';
    } else if (tabIndex === '3') {
      tabName = 'Results';
    }

    if (prefix === 'matrix') {
      gaEvent('RRW', 'ACESSO AO ECRÃ', `${tabName}`);
    } else {
      gaEvent('IPRAM', 'ACESSO AO ECRÃ', `${tabName}`);
    }

    if (tabIndex === '3') {
      let isValid = true;
      let isError = false;
      const formLimit = props.isMatrix ? 18 : 15;

      if (avaliationForms.length) {
        handleSubmitAvaliationForm();
      }

      state[prefix].form.forEach(column => {
        const limit = column.length;

        if (limit < 0 || limit < formLimit) {
          isValid = false;
          isError = true;

          return;
        }

        for (let index = 0; index < limit; index++) {
          if (column[index] === undefined) {
            isValid = false;
            isError = true;

            return;
            // eslint-disable-next-line no-else-return
          }
        }
      });

      if (isError) {
        message.error(language === 'pt' ? 'Conclua a selecção para avançar!' : 'Complete the selection to proceed!');
      }
      if (isValid) {
        setState({
          ...state,
          tab: tabIndex
        });
        // eslint-disable-next-line no-use-before-define
        gaSend();
      }
    } else {
      setState({
        ...state,
        tab: tabIndex
      });
    }
  };

  const getOption = (path, defaults = null) => {
    return get(path, state, defaults);
  };

  const calculatEvaluationSection = (idColumn, position) => {
    const form = [...state[prefix].form];
    const column = form[idColumn];

    const totals = [...state[prefix].totals];

    const section = position <= 7 ? column.slice(2, 8) : column.slice(8, 15);
    const idx = position <= 7 ? 0 : 1;
    const sum = section.reduce((one, two) => one + two);

    totals[idColumn][idx] = sum;

    setState(prevState => ({
      ...prevState,
      [prefix]: {
        ...prevState[prefix],
        totals
      }
    }));
  };

  const gaSend = () => {
    if (prefix === 'matrix') {
      const collection = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17];
      const form = [...state[prefix].form];
      const countForms = Object.keys(form);

      countForms.map(item => (
        // eslint-disable-next-line no-sequences
        gaEvent('RRW', `RRW-TOTAL PROJECTS`, `${countForms.length}`),

        collection.map(question =>
          gaEvent('RRW', `RRW-QUESTION ${question}`, `${form[item][question] === 0 ? 'NÃO' : 'SIM'}`)
        ))
      );
    } else {
      const collection = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
      const form = [...state[prefix].form];
      const totals = [...state[prefix].totals];
      const total = Object.keys(totals);

      total.map(item => (
        // eslint-disable-next-line no-sequences
        gaEvent('IPRAM', `IPRAM-TOTAL PROJECTS`, `${total.length}`),
        gaEvent('IPRAM', `IPRAM-TOTAL MARKET`, `${totals[item][0]}`),
        gaEvent('IPRAM', `IPRAM-TOTAL PRODUCT`, `${totals[item][1]}`),
        gaEvent('IPRAM', `IPRAM-BUDGET`, `${form[item][1]}€`),

        collection.map((question, index) =>
          gaEvent('IPRAM', `IPRAM-QUESTION ${++index}`, `${form[item][question]}`)

        )
      ));
    }
  };

  const addProjectAnswer = (target, idColumn, position) => {
    const form = [...state[prefix].form];
    const column = form[idColumn];
    const targetValue = typeof target === 'object' ? target.value : target;

    column[position] = targetValue;

    if (props.isEvaluation && position === 1) {
      column[position] = Number(targetValue);
    }

    setState(prevState => ({
      ...prevState,
      [prefix]: {
        ...prevState[prefix],
        form
      }
    }));

    if (props.isEvaluation) {
      if (column.length >= 3) {
        calculatEvaluationSection(idColumn, position);
      }
    }
  };

  // ADD COLUMN
  const addColumn = columnId => {
    const id = columnId;
    const columns = [...state[prefix].form];
    const col = [];

    if (columns.length <= 5) {
      col.id = Math.random().toString(36).substring(7);
      col[0] = (language === 'pt' ? 'Projecto' : 'Project')+` ${String.fromCharCode('A'.charCodeAt() + id)}`;
      columns.push(col);

      if (props.isEvaluation) {
        const columnsTotals = [...state[prefix].totals];

        columnsTotals.push([0, 0]);
        setState(prevState => ({
          ...prevState,
          [prefix]: {
            ...prevState[prefix],
            form: columns,
            totals: columnsTotals
          }
        }));
      } else {
        setState(prevState => ({
          ...prevState,
          [prefix]: {
            ...prevState[prefix],
            form: columns
          }
        }));
      }
    }
  };

  const removeColumn = index => {
    const column = [...state[prefix].form];

    if (column.length === 1) {
      return;
    }

    column.splice(index, 1);

    if (props.isEvaluation) {
      const columnsTotals = [...state[prefix].totals];

      columnsTotals.splice(index, 1);

      setState(prevState => ({
        ...prevState,
        [prefix]: {
          ...prevState[prefix],
          form: column,
          totals: columnsTotals
        }
      }));
    } else {
      setState(prevState => ({
        ...prevState,
        [prefix]: {
          ...prevState[prefix],
          form: column
        }
      }));
    }
  };

  return (
    <IntlProvider locale={language} messages={languageTranslation}>
      <ApplicationProvider
        value={{
          addColumn,
          addProjectAnswer,
          getOption,
          handleChangeTab,
          handleSetAvaliationForm,
          handleSubmitAvaliationForm,
          isEvaluation: props.isEvaluation,
          isMatrix: props.isMatrix,
          print,
          removeColumn,
          setSwipper,
          tab: state.tab
        }}
      >
        {props.isMatrix ? <Helmet>
          <style
            media={'print'}
            type={'text/css'}
          >
            {`@page {
              size: landscape;
          }`}
          </style>
          <title>PROJECT CHECK | COTEC Portugal</title>
          <meta
            content={<FormattedMessage id="homepage.project.meta"/>}
            name={'description'}
          />
        </Helmet> : <Helmet>
            <title>RISK CHECK | COTEC Portugal</title>
            <meta
               content={<FormattedMessage id="homepage.risk.meta"/>}
              name={'description'}
            />
          </Helmet>}
        <div className={'body-wrapper'}>
          <Header onChangeLanguage={handleChangeLanguage} language={language}/>
          <Tab />
        </div>
      </ApplicationProvider>
    </IntlProvider>
  );
}

App.propTypes = {
  isEvaluation: bool.isRequired,
  isMatrix: bool.isRequired
};

export default App;
